import { ref, computed, h, onMounted, onUnmounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5e17db5f"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode(" 用于判断该商品是否处于可用状态 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 有效：可随版本发布 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 失效：该商品已停用 ")], -1));
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  class: "elli-multiple-2"
};
const _hoisted_4 = {
  key: 0,
  class: "channel-price-cell"
};
const _hoisted_5 = {
  class: "channel-price-row"
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 2,
  class: "price-box flex-list"
};
const _hoisted_8 = {
  key: 0,
  class: "test-box"
};
const _hoisted_9 = {
  class: "badge-test"
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  class: "elli-multiple-2"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "statusColor wait"
}, null, -1));
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "statusColor inprogress"
}, null, -1));
const _hoisted_16 = {
  key: 2
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "statusColor refuse"
}, null, -1));
const _hoisted_18 = {
  class: "preLine"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, " 已驳回", -1));
const _hoisted_20 = {
  key: 3
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "statusColor success"
}, null, -1));
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = {
  key: 2
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  key: 1
};
const _hoisted_27 = {
  key: 2
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  key: 1
};
const _hoisted_30 = {
  key: 2
};
const _hoisted_31 = {
  key: 3
};
const _hoisted_32 = ["title"];
import { QuestionCircleOutlined, WarningFilled, SwapOutlined } from '@ant-design/icons-vue';
import { useStore } from '@/store';
import Empty from '@/components/Empty.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import useDetailHooks from '@/views/goodsManage/goodsSetting/hooks/useDetailHooks';
import ChannelStatusCell from '@/components/channelStatus/ChannelStatusCell.vue';
import { getChannelStatusRows, getThirdPartyPriceRows, getChannelFieldValues, getDefaultChannel, isMultiChannel } from '@/components/channelStatus/channelStatus';
export default /*#__PURE__*/_defineComponent({
  __name: 'TableContent',
  props: ['dataSource', 'columns', 'isGp', 'selectedRowKeys', 'tableLoading', 'prodChnl', 'productScene', 'isDefault', 'showSwapIcon'],
  emits: ['goDel', 'goOnline', 'goOffline', 'goUpd', 'onSelectChange', 'changeChnl'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const {
      prodTypeOptions
    } = useDetailHooks();
    const tableHeight = ref(500);
    const osList = [{
      label: '虚拟支付',
      value: 1
    }, {
      label: '客服会话',
      value: 2
    }];
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const locale = {
      emptyText: h(Empty)
    }; // 缺省提示
    const goDel = record => {
      emits('goDel', record);
    };
    const goOnline = record => {
      emits('goOnline', record);
    };
    const goOffline = record => {
      emits('goOffline', record);
    };
    const goUpd = record => {
      emits('goUpd', record);
    };
    const onSelectChange = (keyArr, rows) => {
      emits('onSelectChange', keyArr, rows);
    };
    // 苹果 / 谷歌走多渠道展示：默认价格、同步状态、商品状态三列改为按渠道分行
    const isMultiChnl = computed(() => isMultiChannel(props.prodChnl));
    const defaultChannel = computed(() => getDefaultChannel(props.prodChnl));
    // 编辑 / 停用 / 启用的准入：多渠道要求默认渠道与所有已开启三方渠道的状态一致，其余渠道沿用外层标量
    const fieldValues = (record, field) => isMultiChnl.value ? getChannelFieldValues(record, field, props.prodChnl) : [record[field]];
    const canEdit = record => fieldValues(record, 'modStatus').every(value => value !== 0);
    const canOffline = record => fieldValues(record, 'prodStatus').every(value => value === 10);
    const canOnline = record => fieldValues(record, 'prodStatus').every(value => value === 20);
    const getComingPrices = computed(() => record => {
      var _record$bizInfo, _record$bizInfo2;
      if (record !== null && record !== void 0 && (_record$bizInfo = record.bizInfo) !== null && _record$bizInfo !== void 0 && _record$bizInfo.upcomingPrices && record !== null && record !== void 0 && (_record$bizInfo2 = record.bizInfo) !== null && _record$bizInfo2 !== void 0 && (_record$bizInfo2 = _record$bizInfo2.upcomingPrices) !== null && _record$bizInfo2 !== void 0 && _record$bizInfo2.prodPrice) {
        return '即将生效价格:' + record.bizInfo.upcomingPrices.prodPriceCurrency + ' ' + record.bizInfo.upcomingPrices.prodPrice;
      }
      return '';
    });
    const toolText = computed(() => {
      return props.isDefault ? '点击切换美元价格' : '点击切换默认价格';
    });
    const changeDefault = () => {
      emits('changeChnl');
    };
    const calculateTableHeight = () => {
      const windowHeight = window.innerHeight;
      const otherHeight = 40 + 54 + 64 + 32 + 10 + 55 + 40 + 40 + 64 + 60;
      tableHeight.value = windowHeight - otherHeight;
    };
    onMounted(() => {
      calculateTableHeight();
      window.addEventListener('resize', calculateTableHeight);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', calculateTableHeight);
    });
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(_component_a_table, {
        bordered: "",
        columns: props.columns,
        "row-key": "id",
        "row-selection": {
          selectedRowKeys: props.selectedRowKeys,
          onChange: onSelectChange,
          preserveSelectedRowKeys: true
        },
        scroll: {
          x: 1800,
          y: tableHeight.value
        },
        "data-source": props.dataSource,
        locale: locale,
        pagination: false,
        loading: __props.tableLoading
      }, {
        headerCell: _withCtx(({
          column
        }) => [column.dataIndex === 'publishStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_a_tooltip, {
          placement: "top"
        }, {
          title: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(props.productScene === 'MALL' ? '内购后台发布结果；微信后台需手工上传配置表' : '用于判断商品信息是否已成功上传到三方后台'), 1)]),
          default: _withCtx(() => [_createTextVNode("   "), _createVNode(_unref(QuestionCircleOutlined), {
            class: "tableHeadIcon"
          })]),
          _: 1
        })], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_a_tooltip, {
          placement: "top"
        }, {
          title: _withCtx(() => [_hoisted_1]),
          default: _withCtx(() => [_createTextVNode("   "), _createVNode(_unref(QuestionCircleOutlined), {
            class: "tableHeadIcon"
          })]),
          _: 1
        })], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodPrice' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createTextVNode(" 默认价格 "), _createVNode(_component_a_tooltip, {
          placement: "top",
          title: _unref(toolText)
        }, {
          default: _withCtx(() => [props.showSwapIcon ? (_openBlock(), _createBlock(_unref(SwapOutlined), {
            key: 0,
            class: _normalizeClass({
              isUsd: !props.isDefault
            }),
            onClick: changeDefault
          }, null, 8, ["class"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["title"])], 64)) : _createCommentVNode("", true)]),
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _record$mallImage, _unref$find, _osList$find, _unref2, _unref3, _unref4, _unref5;
          return [column.dataIndex === 'mallImage' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [(_record$mallImage = record.mallImage) !== null && _record$mallImage !== void 0 && _record$mallImage.imageUrl ? (_openBlock(), _createBlock(_component_a_image, {
            key: 0,
            src: record.mallImage.imageUrl,
            width: 48,
            height: 48
          }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))], 64)) : _createCommentVNode("", true), ['remark', 'prodId'].includes(column.dataIndex) ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 1,
            placement: "topLeft"
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record[column.dataIndex]), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(record[column.dataIndex]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'prodType' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createTextVNode(_toDisplayString((_unref$find = _unref(prodTypeOptions).find(item => item.value === record.prodType)) === null || _unref$find === void 0 ? void 0 : _unref$find.label), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodPrice' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 3
          }, [_unref(isMultiChnl) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_a_tooltip, {
            title: `${_unref(defaultChannel).tooltip.replace('状态', '')}官方价格`
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              class: _normalizeClass(["channel-tag", _unref(defaultChannel).key])
            }, _toDisplayString(_unref(defaultChannel).tag), 3)]),
            _: 1
          }, 8, ["title"]), !props.isDefault ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("span", null, _toDisplayString(record.usProdPriceCurrency) + " ", 1), _createElementVNode("span", null, _toDisplayString(record.usProdPrice), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_withDirectives(_createElementVNode("span", null, _toDisplayString(record.prodPriceCurrency) + " ", 513), [[_vShow, record.prodPriceCurrency]]), _createElementVNode("span", null, _toDisplayString(record.prodPrice), 1), _createVNode(_component_a_tooltip, null, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(getComingPrices)(record)), 1)]),
            default: _withCtx(() => {
              var _record$bizInfo3;
              return [record.bizInfo && record.bizInfo.upcomingPrices && !(record !== null && record !== void 0 && (_record$bizInfo3 = record.bizInfo) !== null && _record$bizInfo3 !== void 0 && (_record$bizInfo3 = _record$bizInfo3.upcomingPrices) !== null && _record$bizInfo3 !== void 0 && _record$bizInfo3.isDeleted) ? (_openBlock(), _createBlock(_unref(WarningFilled), {
                key: 0,
                style: {
                  "color": "#f9ab13",
                  "margin-left": "6px"
                }
              })) : _createCommentVNode("", true)];
            }),
            _: 2
          }, 1024)], 64))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getThirdPartyPriceRows)(record, props.prodChnl), row => {
            return _openBlock(), _createElementBlock("div", {
              key: row.key,
              class: "channel-price-row"
            }, [_createVNode(_component_a_tooltip, {
              title: row.tooltip
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                class: _normalizeClass(["channel-tag", row.key])
              }, _toDisplayString(row.tag), 3)]),
              _: 2
            }, 1032, ["title"]), _createElementVNode("span", null, _toDisplayString(row.currency) + " " + _toDisplayString(row.price), 1)]);
          }), 128))])) : !props.isDefault ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(record.usProdPriceCurrency) + " ", 1), _createElementVNode("span", null, _toDisplayString(record.usProdPrice) + " ", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_withDirectives(_createElementVNode("span", null, _toDisplayString(record.prodPriceCurrency) + " ", 513), [[_vShow, record.prodPriceCurrency]]), record.testStatus ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createTextVNode(_toDisplayString(record.prodPrice) + " ", 1), _createElementVNode("span", _hoisted_9, [_createVNode(SvgIcon, {
            "icon-class": "isTest",
            "class-name": "test-icon"
          })])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(record.prodPrice), 1), _createVNode(_component_a_tooltip, null, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(getComingPrices)(record)), 1)]),
            default: _withCtx(() => {
              var _record$bizInfo4;
              return [record.bizInfo && record.bizInfo.upcomingPrices && !(record !== null && record !== void 0 && (_record$bizInfo4 = record.bizInfo) !== null && _record$bizInfo4 !== void 0 && (_record$bizInfo4 = _record$bizInfo4.upcomingPrices) !== null && _record$bizInfo4 !== void 0 && _record$bizInfo4.isDeleted) ? (_openBlock(), _createBlock(_unref(WarningFilled), {
                key: 0,
                style: {
                  "color": "#f9ab13",
                  "margin-left": "6px"
                }
              })) : _createCommentVNode("", true)];
            }),
            _: 2
          }, 1024)]))]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodName' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 4,
            placement: "topLeft"
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.prodName), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, _toDisplayString(record.prodName), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'os' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 5
          }, [_createTextVNode(_toDisplayString((_osList$find = osList.find(item => item.value === record.os)) === null || _osList$find === void 0 ? void 0 : _osList$find.label), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'approvalStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 6
          }, [record.approvalStatus === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, [_hoisted_13, _createTextVNode(" 待提交 ")])) : _createCommentVNode("", true), record.approvalStatus === 10 ? (_openBlock(), _createElementBlock("span", _hoisted_14, [_hoisted_15, _createTextVNode(" 审核中 ")])) : _createCommentVNode("", true), record.approvalStatus === 20 ? (_openBlock(), _createElementBlock("span", _hoisted_16, [_hoisted_17, _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_18, _toDisplayString(record.rejectMsg), 1)]),
            default: _withCtx(() => [_hoisted_19]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true), record.approvalStatus === 30 ? (_openBlock(), _createElementBlock("span", _hoisted_20, [_hoisted_21, _createTextVNode(" 已通过 ")])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), column.dataIndex === 'publishStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 7
          }, [_unref(isMultiChnl) ? (_openBlock(), _createBlock(ChannelStatusCell, {
            key: 0,
            rows: _unref(getChannelStatusRows)(record, 'publish', props.prodChnl)
          }, null, 8, ["rows"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [record.publishStatus === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_22, "--")) : _createCommentVNode("", true), record.publishStatus === 10 ? (_openBlock(), _createElementBlock("span", _hoisted_23, [_createVNode(SvgIcon, {
            class: "tableIcon",
            "icon-class": "send_success"
          }), _createTextVNode(" 成功 ")])) : _createCommentVNode("", true), record.publishStatus === 20 ? (_openBlock(), _createElementBlock("span", _hoisted_24, [_createVNode(SvgIcon, {
            class: "tableIcon",
            "icon-class": "send_fail"
          }), _createTextVNode(" 失败 ")])) : _createCommentVNode("", true)], 64))], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 8
          }, [_unref(isMultiChnl) ? (_openBlock(), _createBlock(ChannelStatusCell, {
            key: 0,
            rows: _unref(getChannelStatusRows)(record, 'product', props.prodChnl)
          }, null, 8, ["rows"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [record.prodStatus === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_25, "--")) : _createCommentVNode("", true), record.prodStatus === 10 ? (_openBlock(), _createElementBlock("span", _hoisted_26, [_createVNode(SvgIcon, {
            class: "tableIcon",
            "icon-class": "send_success"
          }), _createTextVNode(" 有效 ")])) : _createCommentVNode("", true), record.prodStatus === 20 ? (_openBlock(), _createElementBlock("span", _hoisted_27, [_createVNode(SvgIcon, {
            class: "tableIcon",
            "icon-class": "outline"
          }), _createTextVNode(" 失效 ")])) : _createCommentVNode("", true)], 64))], 64)) : _createCommentVNode("", true), column.dataIndex === 'optType' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 9
          }, [record.optType === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_28, "新增")) : _createCommentVNode("", true), record.optType === 10 ? (_openBlock(), _createElementBlock("span", _hoisted_29, "修改")) : _createCommentVNode("", true), record.optType === 20 ? (_openBlock(), _createElementBlock("span", _hoisted_30, "停用")) : _createCommentVNode("", true), record.optType === 30 ? (_openBlock(), _createElementBlock("span", _hoisted_31, "启用")) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), column.dataIndex === 'approver' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 10,
            placement: "right"
          }, {
            title: _withCtx(() => {
              var _record$bizInfo5;
              return [_createTextVNode(_toDisplayString((_record$bizInfo5 = record.bizInfo) !== null && _record$bizInfo5 !== void 0 && _record$bizInfo5.approvalUsers ? record.bizInfo.approvalUsers : '--'), 1)];
            }),
            default: _withCtx(() => {
              var _record$bizInfo6, _record$bizInfo7;
              return [_createElementVNode("span", {
                title: (_record$bizInfo6 = record.bizInfo) !== null && _record$bizInfo6 !== void 0 && _record$bizInfo6.approvalUsers ? record.bizInfo.approvalUsers : '-',
                style: {
                  "display": "inline-block",
                  "max-width": "90%",
                  "white-space": "nowrap",
                  "overflow": "hidden",
                  "text-overflow": "ellipsis"
                }
              }, _toDisplayString((_record$bizInfo7 = record.bizInfo) !== null && _record$bizInfo7 !== void 0 && _record$bizInfo7.approvalUsers ? record.bizInfo.approvalUsers : '--'), 9, _hoisted_32)];
            }),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 11
          }, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
            disabled: !canEdit(record),
            class: "tableBtn",
            type: "link",
            onClick: $event => goUpd(record)
          }, {
            default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
            _: 2
          }, 1032, ["disabled", "onClick"])), [[_directive_permission, {
            permissionValue: 'goodsSetting',
            permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
          }]]), record.approvalStatus !== 30 ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            disabled: record.approvalStatus === 10 || record.replicaStatus === 1,
            class: "tableBtn",
            type: "link",
            onClick: $event => goDel(record)
          }, {
            default: _withCtx(() => [_createTextVNode(" 删除 ")]),
            _: 2
          }, 1032, ["disabled", "onClick"])), [[_directive_permission, {
            permissionValue: 'goodsSetting',
            permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
          }]]) : _createCommentVNode("", true), canOffline(record) ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            disabled: record.replicaStatus === 1,
            class: "tableBtn",
            type: "link",
            onClick: $event => goOffline(record)
          }, {
            default: _withCtx(() => [_createTextVNode(" 停用 ")]),
            _: 2
          }, 1032, ["disabled", "onClick"])), [[_directive_permission, {
            permissionValue: 'goodsSetting',
            permissionArr: (_unref4 = _unref(userInfo)) === null || _unref4 === void 0 ? void 0 : _unref4.permissions
          }]]) : _createCommentVNode("", true), canOnline(record) ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            key: 2,
            disabled: record.replicaStatus === 1,
            class: "tableBtn",
            type: "link",
            onClick: $event => goOnline(record)
          }, {
            default: _withCtx(() => [_createTextVNode(" 启用 ")]),
            _: 2
          }, 1032, ["disabled", "onClick"])), [[_directive_permission, {
            permissionValue: 'goodsSetting',
            permissionArr: (_unref5 = _unref(userInfo)) === null || _unref5 === void 0 ? void 0 : _unref5.permissions
          }]]) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "row-selection", "scroll", "data-source", "loading"]);
    };
  }
});